import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr 1fr',
    background: theme.palette.background.default,
    height: 36
  },
  left: {
    display: 'flex',
    justifyContent: 'flex-start',
    borderBottom: `1px solid ${theme.palette.grey[300]}`,
    borderRight: `1px solid ${theme.palette.grey[300]}`,
    padding: '6px 12px',
    alignItems: 'center'
  },
  middle: {
    display: 'flex',
    justifyContent: 'center',
    borderBottom: `1px solid ${theme.palette.grey[300]}`,
    borderRight: `1px solid ${theme.palette.grey[300]}`,
    padding: 6,
    alignItems: 'center'
  },
  right: {
    display: 'flex',
    justifyContent: 'center',
    borderBottom: `1px solid ${theme.palette.grey[300]}`,
    borderRight: `1px solid ${theme.palette.grey[300]}`,
    padding: 6,
    alignItems: 'center'
  },
  text: {
    fontWeight: 600,
    [theme.breakpoints.down('sm')]: {
      fontSize: 12
    }
  },
  discountText: {
    color: theme.palette.error.main,
    [theme.breakpoints.down('sm')]: {
      fontSize: 12
    },
    fontWeight: 600,
    textDecoration: 'line-through',
    marginRight: 8
  },
  formcontrol: { margin: '0px', padding: 0 }
}))

export default useStyles
